<template>
  <div class="role-wrapper">
    <wrapper v-if="hasRes('op_role_create')">
      <el-button
        type="danger"
        size="medium"
        @click="openRoleEditor('create')">添加角色</el-button>
    </wrapper>

    <div class="role-list" v-if="hasRes('op_role_index') && roleList && roleList.length > 0">
      <el-card class="role-card" v-for="role in roleList" :key="role.role_id">
        <div slot="header">
          <span>{{ role.name }}</span>
        </div>
        <div class="res-list">
          <div v-for="(resId, resIndex) in role.resource_id_list" :key="`res-${resIndex}`" class="res-item">
            <el-tag
              type="danger"
              size="medium">
              <el-tooltip placement="top">
                <div slot="content">
                  <span>前端标识: {{ resId in resMap ? resMap[resId].code : '' }}</span><br/>
                  <span>请求方法：{{ resId in resMap ? resMap[resId].method : '' }}</span><br/>
                  <span>请求地址：{{ resId in resMap ? resMap[resId].url : '' }}</span>
                </div>
                <span class="res-name">{{ resId in resMap ? resMap[resId].name : '' }}</span>
              </el-tooltip>
            </el-tag>
          </div>
        </div>
        <div class="operation">
          <el-button
            type="text"
            @click="openRoleEditor('update', role)">修改</el-button>
          <el-button
            type="text"
            class="danger-text"
            @click="onRoleDeleteClick(role)">删除</el-button>
        </div>
      </el-card>
    </div>

    <wrapper class="empty-tips" v-else-if="hasRes('op_role_index')">
      <div> <i class="iconfont icon-searching"></i> </div>
      <h3 v-if="hasRes('op_role_create')">您还没有角色，点击上方按钮即可进行添加</h3>
      <h3 v-else>您还没有角色，请联系管理员添加</h3>
    </wrapper>

    <dialog-op-role-editor
      :mode="roleEditorMode"
      :res-cate-list="resCateList"
      v-model="roleEditorDialogVisible"
      :role="roleEditorModel"
      @submit="onRoleEditorSubmit" />

  </div>
</template>

<script>
import Wrapper from '@/components/Wrapper'
import DialogOpRoleEditor from '@/pages/op/acl/components/DialogOpRoleEditor'

import { mapState, mapGetters } from 'vuex'
import aclApi from '@/api/aclApi'

export default {
  name: 'OpRole',
  components: {
    Wrapper,
    DialogOpRoleEditor
  },
  data () {
    return {
      loading: true,
      sort: '',

      // 角色列表
      roleList: [],
      roleCount: 0,

      // 资源分类列表
      resCateList: [],
      resMap: {},

      // 角色编辑器相关
      roleEditorDialogVisible: false,
      roleEditorMode: 'create',
      roleEditorModel: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize'
    ]),
    ...mapState('opUser', [
      'userInfo'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    openRoleEditor (mode = 'create', role = {}) {
      if (mode === 'update') {
        this.roleEditorModel = role
      }
      this.roleEditorMode = mode
      this.roleEditorDialogVisible = true
    },
    onRoleEditorSubmit (form) {
      if (this.roleEditorMode === 'create') {
        // 添加角色
        this.addRole(form)
      } else {
        form.roleId = this.roleEditorModel.role_id
        this.updateRole(form)
      }
    },
    async addRole (form) {
      try {
        const { rcode, msg } = await aclApi.addOpRole(form)
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '添加角色成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '添加角色失败'
        })
      }
    },
    async updateRole (form) {
      try {
        const { rcode, msg } = await aclApi.updateOpRole(form)
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '修改角色成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '修改角色失败'
        })
      }
    },
    async onRoleDeleteClick (role) {
      try {
        await this.$confirm('此操作将永远删除角色', '是否继续', '删除角色', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const { rcode, msg } = await aclApi.delOpRole({
          roleId: role.role_id
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '删除角色成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    // 更新表格数据
    async updateTableData () {
      this.loading = true

      try {
        const { rcode, msg, data } = await aclApi.getOpRoles({
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }

        this.roleList = data.list
        this.roleCount = data.count
      } catch (err) {
        console.log(err)
        this.loading = false

        this.$message({
          type: 'error',
          message: '获取角色列表失败'
        })
      }
    },
    // 获取权限资源列表
    async getResCateList () {
      try {
        const { rcode, msg, data } = await aclApi.getOpResources({
          page: 1,
          pageSize: 9999
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }

        this.resCateList = data.list
        for (const resCate of this.resCateList) {
          for (const res of resCate.resource_list) {
            this.resMap[res.resource_id] = res
          }
        }
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取资源列表失败'
        })
      }
    }
  },
  mounted () {
    this.updateTableData()
    this.getResCateList()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.role-wrapper {

  .role-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    width: 96%;
    margin: 0 auto;

    .role-card {
      margin-right: 1.5rem;
      margin-bottom: 1.5rem;
      width: 30%;
      height: 330px;
      position: relative;

      .res-list {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
        max-height: 200px;
        overflow-y: auto;

        .res-item {
          margin: 5px 5px 0 0;
        }
      }

      .operation {
        position: absolute;
        bottom: 0;
        right: 30px;
      }
    }
  }

  .empty-tips {
    text-align: center;
    color: $primaryColor;

    i {
      font-size: 6rem;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/OpRole.vue